import {z} from 'zod';

import {BaseVoidResponseSchema, VatTypeSchema} from '@dms/api/shared';

export const CustomVatRateSourceSchema = z.enum([
  'MANUAL',
  'ABROAD_SALE',
  'FREE_OF_CHARGE',
  'NON_TAX_DEDUCTIBLE',
]);

export type CustomVatRateSource = z.infer<typeof CustomVatRateSourceSchema>;

export const GetServiceOrderCustomVatRateApiResponseSchema = z
  .object({
    isCustomVatEnabled: z.boolean(),
    isChangeAllowed: z.boolean(),
    vatType: VatTypeSchema.nullable().optional(),
    vatSource: CustomVatRateSourceSchema.nullable().optional(),
  })
  .nullable();

export type GetServiceOrderCustomVatRateApiResponse = z.infer<
  typeof GetServiceOrderCustomVatRateApiResponseSchema
>;

export const GetServiceOrderCustomVatRateApiArgSchema = z.object({
  serviceCaseId: z.string(),
  serviceOrderId: z.string(),
});

export type GetServiceOrderCustomVatRateApiArg = z.infer<
  typeof GetServiceOrderCustomVatRateApiArgSchema
>;

export const PatchServiceOrderCustomVatRateApiResponseSchema = BaseVoidResponseSchema;

export type PatchServiceOrderCustomVatRateApiResponse = z.infer<
  typeof PatchServiceOrderCustomVatRateApiResponseSchema
>;

export const PatchServiceOrderCustomVatRateApiArgSchema = z.object({
  serviceCaseId: z.string(),
  serviceOrderId: z.string(),
  body: z.object({
    isCustomVatEnabled: z.boolean(),
    vatType: VatTypeSchema.nullable().optional(),
  }),
});

export type PatchServiceOrderCustomVatRateApiArg = z.infer<
  typeof PatchServiceOrderCustomVatRateApiArgSchema
>;
